/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { setCardSelected } from '../../../store/actions/OnboardingRedesign';

class OnboardingCardWithImageRedesign extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.dispatchSetCardSelected(this.props.step, this.props.value);
  }

  render() {
    const { isCardSelected, text, value } = this.props;

    return (
      <div
        className={classNames('redesign-card-with-image', {
          active: isCardSelected,
        })}
        onClick={this.onClick}
      >
        {isCardSelected ? (
          <div className="checker">
            <i className="fas fa-check" />
          </div>
        ) : null}
        <div className="red-card-image mx-auto">
          <div
            className={classNames(
              'onboarding-card__image',
              `onboarding-card__image--${value}`,
            )}
          />
        </div>
        <div className="text-center card-title-el">
          <div className="red-card-subtitle mx-auto">{text}</div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchSetCardSelected: (step, value) => {
    dispatch(setCardSelected(step, value));
  },
});

export default connect(
  null,
  mapDispatchToProps,
)(OnboardingCardWithImageRedesign);



// WEBPACK FOOTER //
// ./src/containers/OnboardingRedesign/Cards/OnboardingCardWithImageRedesign.js